import { Box, Button } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings.js";
import { useDialog } from "../../hooks/useDialog";
import { DrivingLicenseAuthorityFormTemplateDialog } from "./DrivingLicenseAuthorityFormTemplateDialog.js";

export function EditDrivingLicenseAuthorityFormTemplateButton() {
  const { dialogProps, openDialog } = useDialog("EditDrivingLicenseAuthorityFormTemplateDialog");
  return (
    <Box>
      <Button startIcon={<SettingsIcon />} variant="outlined" onClick={openDialog}>
        Template bearbeiten
      </Button>
      {dialogProps.open && <DrivingLicenseAuthorityFormTemplateDialog {...dialogProps} />}
    </Box>
  );
}
